import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Calculator from "./components/Calculator";
import GetStartedModal from "./components/GetStartedModal";
import {
  BuyerBuyer,
  WhoCan,
  Agreement,
  Team,
  Investor,
  MoreThanGift,
  HowItWorks,
  TwoWaysFinal,
} from "./components/Sections";
import Footer from "./components/Footer";

const LandingPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);

  return (
    <div className="min-h-screen bg-white">
      <Header onGetStarted={openModal} />
      <main>
        <Hero onGetStarted={openModal} />
        <BuyerBuyer onGetStarted={openModal} />
        <WhoCan />
        <Calculator />
        <Agreement />
        <Team />
        <Investor onGetStarted={openModal} />
        <MoreThanGift onGetStarted={openModal} />
        <HowItWorks />
        <TwoWaysFinal onGetStarted={openModal} />
      </main>
      <Footer onGetStarted={openModal} />
      <GetStartedModal open={modalOpen} onOpenChange={setModalOpen} />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
